import { Bus } from '../bus.js';

export function notifyError(message, autoClose, options) {
  notify('error', message, autoClose, options);
}

export function notifyInfo(message, autoClose, options) {
  notify('info', message, autoClose, options);
}

export function notifySuccess(message, autoClose, options) {
  notify('success', message, autoClose, options);
}

export function notifyWarning(message, autoClose, options) {
  notify('warning', message, autoClose, options);
}

function notify(type, message, autoClose, options) {
  Bus.$emit('notification', {
    autoClose,
    message,
    options,
    type,
  });
}
